export default {
    TWO_D: '2d',
    WEBGL: 'webgl',
    WEBGL2: 'webgl2',
    SVG: 'svg'
};